// britam-admin.ts
import { FormattedMessage } from 'react-intl';
import { IconDashboard, IconDeviceAnalytics, IconFileCheck, IconPencilPlus, IconFileX, IconSettings } from '@tabler/icons-react';
import { getUserRegionFromStorage } from 'Application/utils';

const icons = {
    IconDashboard,
    IconDeviceAnalytics,
    IconFileCheck,
    IconPencilPlus,
    IconFileX,
    IconSettings
};

const countryMenuItems = {
    Kenya: {
        id: 'generateQuoteKenya',
        title: <FormattedMessage id="Buy Now" />,
        type: 'item',
        url: '/britam-underwriter/travel-portal/generate-quote',
        icon: icons.IconPencilPlus,
        breadcrumbs: false
    },
    Rwanda: {
        id: 'generateQuoteRwanda',
        title: <FormattedMessage id="Buy Now" />,
        type: 'item',
        url: '/britam-underwriter/travel-portal/generate-quote-rw',
        icon: icons.IconPencilPlus,
        breadcrumbs: false
    }
};
const userCountry = (getUserRegionFromStorage() ?? 'Kenya') as keyof typeof countryMenuItems;
const selectedCountryItem = countryMenuItems[userCountry];

export const BritamUnderwriteHomeItem = {
    id: 'britam-underwriter',
    title: <FormattedMessage id="Underwriter" />,
    icon: icons.IconDashboard,
    type: 'group',
    children: [
        {
            id: 'home',
            title: <FormattedMessage id="Home" />,
            type: 'item',
            url: '/britam-underwriter/home',
            icon: icons.IconDashboard,
            breadcrumbs: false
        }
    ]
};

export const UnderwriteTravelInsurance = {
    id: 'travelInsurance',
    title: <FormattedMessage id="Travel Insurance" />,
    icon: icons.IconDashboard,
    type: 'group',
    children: [
        selectedCountryItem, // Dynamically select based on userCountry
        {
            id: 'Completed Transactions',
            title: <FormattedMessage id="Completed Transactions" />,
            type: 'item',
            url: '/britam-underwriter/travel-portal/completed-transactions',
            icon: icons.IconFileCheck,
            breadcrumbs: false
        },
        {
            id: 'Generated Quotes',
            title: <FormattedMessage id="Generated Quotes" />,
            type: 'item',
            url: '/britam-underwriter/travel-portal/generated-quotes',
            icon: icons.IconFileX,
            breadcrumbs: false
        }
        // {
        //     id: 'travelPlans',
        //     title: <FormattedMessage id="Travel Plans" />,
        //     type: 'item',
        //     url: '/agency/travel-portal/travel-plans',
        //     icon: icons.IconPlane,
        //     breadcrumbs: false
        // }
    ]
};

export const BritamUnderwriteProducts = {
    id: 'britam-products',
    title: <FormattedMessage id="Products" />,
    icon: icons.IconDashboard,
    type: 'group',
    children: [
        {
            id: 'britam-underwriter-travel',
            title: <FormattedMessage id="Travel" />,
            icon: icons.IconDashboard,
            type: 'collapse',
            children: [
                {
                    id: 'britam-underwriter-travel-setup',
                    title: <FormattedMessage id="Setup" />,
                    type: 'item',
                    url: '/britam-underwriter/products/travel/setup',
                    breadcrumbs: false
                },
                {
                    id: 'britam-underwriter-travel-reports',
                    title: <FormattedMessage id="Reports" />,
                    type: 'item',
                    url: '/britam-underwriter/products/travel/reports',
                    breadcrumbs: false
                }
            ]
        }
    ]
};

export const BritamUnderwriteAgencies = {
    id: 'britam-agencies',
    title: <FormattedMessage id="Agencies" />,
    icon: icons.IconDashboard,
    type: 'group',
    children: [
        {
            id: 'britam-agencies-agencies',
            title: <FormattedMessage id="Agencies" />,
            type: 'item',
            url: '/britam-underwriter/agencies',
            icon: icons.IconDashboard,
            breadcrumbs: false
        }
    ]
};

export const Underwritersupport = {
    id: 'support',
    icon: icons.IconDashboard,
    type: 'group',
    children: [
        // {
        //     id: 'support',
        //     title: <FormattedMessage id="Support" />,
        //     type: 'item',
        //     url: '/agency/support',
        //     icon: icons.IconHelpHexagon,
        //     breadcrumbs: false
        // },
        {
            id: 'Settings',
            title: <FormattedMessage id="Settings" />,
            type: 'item',
            url: '/britam-underwriter/settings',
            icon: icons.IconSettings,
            breadcrumbs: false
        }
    ]
};
